import Vue from 'vue';
import App from './App.vue'
import router from './router'
import VueIziToast from 'vue-izitoast'; // https://github.com/arthurvasconcelos/vue-izitoast
import 'izitoast/dist/css/iziToast.css';
// import axios from 'axios'
// import VueAxios from 'vue-axios'
import VueMoment from 'vue-moment'
import VueCarousel from 'vue-carousel';
import Popover from 'vue-js-popover';
import BootstrapVue from 'bootstrap-vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueGtm from 'vue-gtm';

/*import bugsnagClient from './bugsnag'
import bugsnagVue from '@bugsnag/plugin-vue'
bugsnagClient.use(bugsnagVue, Vue)*/

Vue.use(VueMoment)
Vue.use(VueCarousel)
Vue.use(Popover)
Vue.use(BootstrapVue)
//Vue.use(VueIziToast)
Vue.use(VueIziToast, {
    timeout:         3000,
    position:        "bottomRight",
    backgroundColor: "#4CAF50",
    color:           "white",
    titleColor:      "#fff",
    messageColor:    "#fff",
    iconColor:       "#fff",
    icon:            "fas fa-check"
});

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCC4BYLxskWaOLGExG58eCPcN5sXnI7Vzw',
        libraries: 'geometry'
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
})

// Vue.use(VueGtm, {
//     id: 'GTM-K5QS7RN',
//     debug: true, // Whether or not display console logs debugs (optional)
//     loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
//     vueRouter: router, // Pass the router instance to automatically sync with router (optional)
//     ignoredViews: ['login', 'register'] // Don't trigger events for specified router names (case insensitive) (optional)
// });


/*if (process.env.NODE_ENV === "development") {
    Vue.prototype.$baseUrl = 'http://dev.oktodigital.com/adoptujkravicku/v2/'
    Vue.prototype.$assetsUrl = Vue.prototype.$baseUrl + 'assets/'
} else {
    Vue.prototype.$baseUrl = 'https://adoptujkravicku.sk/api/public/_'
    Vue.prototype.$assetsUrl = Vue.prototype.$baseUrl + 'assets/'
}*/

router.beforeEach((to, from, next) => {
    next()
})

var vm = new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
});
